import {useAuth} from '../../../auth'
import {businessOptionData, useBusinessSwitcherLabels} from './businessSwitcherLabels'
import {BusinessOptionData, businessCodeOf} from './BusinessOption'
import {businessShortName} from './switchBusiness'

export type CurrentBusiness = {
  id: number
  option: BusinessOptionData
  /** «نام – برچسب», as the pickers write it. */
  display: string
  /** The panel label when the business has one, else its name: a tab title, the header chip. */
  shortName: string
  /** «کد اقتصادی 14000000001», or empty. */
  codeText: string
  /** A steady colour per business, so two tabs look different at a glance (never the only sign: the name is there). */
  color: string
}

/** A steady hue per business id, from the golden angle, at a saturation and lightness readable on white. */
export const businessColor = (id: number) => `hsl(${Math.round((id * 137.508) % 360)} 62% 42%)`

/**
 * The business this tab works in, in the pickers' words (the server's labels when they came). Undefined when the tab
 * has none (an administrator's «همهٔ کسب‌وکارها», a user without a business).
 */
export const useCurrentBusiness = (): CurrentBusiness | undefined => {
  const {currentUser} = useAuth()
  const id = Number(currentUser?.cpi || 0)
  const company = currentUser?.cpl?.find((item) => item.id === id)
  const labels = useBusinessSwitcherLabels(company ? currentUser?.cpl : undefined)
  if (!id) return undefined

  const option = businessOptionData(company || {id, nm: '', nid: ''}, labels[id])
  const name = option.name || `کسب‌وکار ${id}`
  const display = option.label ? `${name} – ${option.label}` : name
  const code = businessCodeOf(option)
  return {
    id,
    option: {...option, name},
    display,
    shortName: businessShortName(name, option.label),
    codeText: code ? `${code.caption} ${code.value}` : '',
    color: businessColor(id),
  }
}
